import { get } from './graphql-utils';
import { getEmployee } from '../graphql/queries';
import { toTitleCase } from './string-utils';
import { getFlowableCasesForOrganisationCaseTable } from '../components/tables/case-table-utils';
import { CaseTableData } from './case-utils';

const cache: Record<string, Promise<CaseTableData[]>> = {};

export function getEnrichedCaseRows(orgId: string, pageSize = 1000): Promise<CaseTableData[]> {
  if (!orgId) return Promise.resolve([]);
  if (cache[orgId]) return cache[orgId];

  cache[orgId] = (async () => {
    const { rows } = await getFlowableCasesForOrganisationCaseTable(orgId, 0, pageSize);

    return Promise.all(
      rows.map(async r => {
        try {
          const emp = await get(getEmployee, r.employeeId).then(res => (res.data as any)?.getEmployee);
          return {
            ...r,
            employeeNumber: emp?.employeeNumber ?? '—',
            employeeFirstName: emp ? toTitleCase(emp.firstName, ' ') : '—',
            employeeLastName: emp ? toTitleCase(emp.lastName, ' ') : '—',
          };
        } catch {
          return r;
        }
      }),
    );
  })();

  return cache[orgId];
}
